<!-- @veltra/icons generated sha256:089af0b5ff3e4765 gen:8 source:src/svg/normal/insert-to-prev.svg -->
<script setup lang="ts">
defineOptions({ name: 'InsertToPrev' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <path d="M16 12H3m13 6H3m7-12H3m18 12V8a2 2 0 0 0-2-2h-5" />
    <path d="m16 8-2-2 2-2" />
  </svg>
</template>
